exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cont{width:300px;height:auto}.cont_img{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}@media (max-width:992px){.cont,.cont_img{width:100%;height:100%}.cont_img{-o-object-fit:cover;object-fit:cover}}", ""]);

// exports
